export default __webpack_public_path__ + "static/media/correo.d9664b41.png";